<template>
    <div>
        <m-assembly-table
                    :formData="formData"
                    :columns="columns"
                    :data="data"
                    :total="total"
                    :settings="settings"
                    :loading="loading"
                    :currentPage="current"
                    :pageSize="pageSize"
                    @onSubmit="onSubmit"
                    @onPageSizeChange="onPageSizeChange"
                    @onCurrentPageChange="onCurrentPageChange">
        </m-assembly-table>
    </div>
</template>

<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import pageForm from '@/components/awesome/page/query/index';
import pagination from '@/components/awesome/page/pagination/index';
import axios from 'axios';
import { qmsApiSwitch, getOrgCode } from '@/utils/tool';
export default {
    name: 'itemBadRecord',
    components: {
        pageForm,
        pagination,
        mAssemblyTable
    },
    data() {
        return {
            supplierInfo: {}, // 供应商baseInfo
            orgId: '',
            language: 'ZH_CN',
            // modal1: false,
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'organizationCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('vendorBadRecord.t5')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: (val) => {
                                console.log('val:', val); // undefined
                                /** 获取erpId-->orgId */
                                this.orgId = this.formData.items[0].value;
                                console.log('this.formData.items[0].value:', this.formData.items[0].value);
                                console.log('this.orgId:', this.orgId);
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        placeholder: '',
                        title: this.$t('vendorBadRecord.t6')
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        disabled: false,
                        // disabled: true,
                        layout: {
                            span: 6,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        style: 'width:130px;',
                        type: 'text',
                        title: this.$t('vendorBadRecord.t7'),
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require')
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'startEndCheckDate',
                        type: 'datePicker',
                        title: this.$t('vendorBadRecord.t16'),
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'datetimerange',
                            format: 'yyyy-MM-dd'
                        },
                        style: 'width:190px;',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require')
                            }
                        }
                    }
                    // {
                    //     value: '',
                    //     field: 'itemName',
                    //     disabled: true,
                    //     layout: {
                    //         span: 24,
                    //         offset: 0,
                    //         row: 2
                    //     },
                    //     options: {
                    //         rows: 1,
                    //         type: 'text'
                    //     },
                    //     style: 'width:550px;',
                    //     type: 'text',
                    //     title: '物料描述'
                    // }
                ],
                buttons: {
                    showSubmit: true,
                    submitText: this.$t('common.queryBtn'),
                    showReset: true,
                    resetText: this.$t('common.clearBtn'),
                    showSearch: true,
                    layout: {
                        span: 24,
                        push: 8
                    }
                }
            },
            columns: {
                showCheckbox: false,
                showButtons: true,
                columns: [
                    {
                        title: this.$t('vendorBadRecord.t13'),
                        key: 'vendorCode',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: this.$t('pdca.t63'),
                        key: 'number',
                        align: 'center',
                        minWidth: 130
                    },
                    {
                        title: this.$t('pdca.t64'),
                        key: 'content',
                        align: 'center',
                        minWidth: 280
                    },
                    /* {
                        title: '物料大类',
                        key: 'type1',
                        align: 'center',
                        width: 130
                    },
                    {
                        title: '物料中类',
                        key: 'type2',
                        align: 'center',
                        width: 160
                    }, */
                    {
                        title: this.$t('pdca.t65'),
                        key: 'type3',
                        align: 'center',
                        minWidth: 150
                    },
                    {
                        title: this.$t('pdca.t66'),
                        key: 'date',
                        align: 'center',
                        minWidth: 155
                    }
                ]
            },
            loading: false,
            total: 0,
            current: 1,
            pageSize: 10,
            condition: null,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true
            },
            data: [],
            mdmCode: '',
            orgList: [],
        };
    },
    methods: {
        /* yyyy-MM-dd */
        dateFormat(value) {
            try {
                return value.getFullYear() + '-' + (((value.getMonth() + 1) < 10) ? '0' + (value.getMonth() + 1) : (value.getMonth() + 1)) + '-' + ((value.getDate() < 10) ? '0' + value.getDate() : value.getDate());
            } catch (err) {
                if (value === undefined || value === 'undefined' || value === null || value === 'null') {
                    return '';
                } else {
                    return value;
                }
            }
        },
        onSubmit(page, pageSize, condition) {
            this.onSearch(page, pageSize, condition);
        },
        /* 页容量改变时触发 */
        onPageSizeChange(page, pageSize, condition) {
            this.onSearch(page, pageSize, condition);
        },
        /* 当前页改变时触发 */
        onCurrentPageChange(page, pageSize, condition) {
            this.onSearch(page, pageSize, condition);
        },
        onSearch(pageIndex, pageSize, condition) {
            console.log('condition::', condition);
            this.data = [];
            this.current = pageIndex;
            this.pageSize = pageSize;
            this.condition = condition;
            this.loading = true;

            var itemCode = condition.itemCode;
            if (itemCode === undefined) {
                itemCode = '';
            }
            var checkedDateBegin = '';
            var checkedDateEnd = '';
            var startEndCheckDate = condition.startEndCheckDate;
            if (startEndCheckDate) {
                let dataTime = startEndCheckDate.split(',');
                checkedDateBegin = dataTime[0];
                checkedDateEnd = dataTime[1];
            }
            axios.get(qmsApiSwitch(this, '/qms2gsc/IqcOutgoing/queryNgListForeign', getOrgCode(this.orgList, this.orgId)), {
                params: {
                    pageIndex,
                    pageSize,
                    orgId: this.orgId,
                    itemCode,
                    checkedDateBegin,
                    checkedDateEnd,
                    supplierCode: this.mdmCode,
                    language: this.$i18n.locale
                }
            }).then(res => {
                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                let result = JSON.parse(jsonStr);
                var IsSucess = result.IsSucess;
                if (IsSucess === true) {
                    let MainResultData = result.MainResultData.DATA;
                    if (!this.isEmptyValue(MainResultData)) {
                        let len = MainResultData.length;
                        let obj = null;
                        for (var i = 0; i < len; i++) {
                            obj = MainResultData[i];
                            this.data.push({
                                vendorCode: obj.SUPPLIER_CODE,
                                number: obj.BARCODE_NUMBER,
                                type1: obj.BIG_CLASS,
                                type2: obj.MID_CLASS,
                                type3: obj.SMALL_CLASS,
                                date: obj.CHECKED_DATE,
                                content: obj.NG_INFO
                            });
                        }
                        this.total = result.MainResultData.TOTAL;
                    } else {
                        this.total = 0;
                    }
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('ShipmentInspection.query_error')
                    });
                }
                this.loading = false;
            });
        },
        isEmptyValue(value) {
            if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
                return true;
            }
            return false;
        },
        /** 初始化检验日期 */
        initDateRange() {
            let now = new Date();
            let subMonth = (now.getMonth() + 1) - 6;
            let subYear = now.getFullYear();
            if (subMonth <= 0) {
                subYear = now.getFullYear() - 1;
                subMonth = subMonth + 12;
            }
            subMonth = ((subMonth < 10) ? '0' + subMonth : subMonth);
            let date1 = subYear + '-' + subMonth + '-01';
            let date2 = now;
            let dateRange = [];
            dateRange.push(date1);
            dateRange.push(this.dateFormat(date2));
            this.formData.items[2].value = dateRange;
        },
    },
    mounted() {
        this.queryVendorAndMdm(this.vendorCode, (data) => {
            this.mdmCode = data;
        });
        this.getSRMInvLovListNew((data) => {
            this.orgList = data;
            data.forEach((item) => {
                item.value = item.erpOrgId;
                item.label = item.organizationName;
            });
            this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = data;
        });
        this.initDateRange();
    }
};
</script>

<style lang='less' scoped>

</style>